import news from './news/config.json'
import transit from './transit/config.json'
import weather from './weather/config.json'

// Panel types with a config.json schema. Adding a panel config = one import + one line here.
// Schema: { [key]: { type, default, placeholder?, label?, disabled?: { [otherKey]: value } } }
export const PANEL_CONFIGS = {
  news,
  transit,
  weather
}

export const getPanelConfigSchema = (type) => PANEL_CONFIGS[type] || null

const DEFAULTS_BY_TYPE = { boolean: false, string: '', number: '' }

export const resolveConfig = (schema, saved = {}) => {
  if (!schema) return {}
  return Object.entries(schema).reduce((values, [key, field]) => {
    const fallback = 'default' in field ? field.default : DEFAULTS_BY_TYPE[field.type]
    values[key] = saved?.[key] ?? fallback
    return values
  }, {})
}

// A field is disabled while every { otherKey: value } pair in its `disabled` rule matches
export const isFieldDisabled = (field, values) =>
  Object.entries(field?.disabled || {}).every(([key, value]) => values[key] === value) &&
  Object.keys(field?.disabled || {}).length > 0

// "useGeolocation" -> "Use geolocation"
export const humanizeKey = (key) => {
  const spaced = key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

// Accepts "41.88,-87.63", "41.88/-87.63" or "41.88 -87.63"
export const parseLatLng = (value) => {
  if (typeof value !== 'string') return null
  const parts = value.trim().split(/\s*[,/]\s*|\s+/)
  if (parts.length !== 2) return null
  const [latitude, longitude] = parts.map(Number)
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null
  return { latitude, longitude }
}

// "chicago, bars ,, live music" -> ["chicago", "bars", "live music"] (deduped, case-insensitive)
export const parseSearchTerms = (value) => {
  if (typeof value !== 'string') return []
  const seen = new Set()
  return value
    .split(',')
    .map((term) => term.trim())
    .filter((term) => {
      const key = term.toLowerCase()
      if (!term || seen.has(key)) return false
      seen.add(key)
      return true
    })
}
